import React from "react";
import { PolicyLayout, H2 } from "./PolicyLayout";
import swapnil from "../asset/swapnil.jpeg";

const stats = [
  ["26 kg", "lost in 5 months"],
  ["7000+", "clients transformed"],
  ["10+ yrs", "mindset & holistic health"],
];

const AboutPage = () => (
  <PolicyLayout title="About Us">
    <div className="grid grid-cols-3 gap-3 text-center">
      {stats.map(([n, l]) => (
        <div key={n} className="bg-green-900 text-white rounded-2xl p-4">
          <p className="text-xl md:text-3xl font-black text-yellow-300">{n}</p>
          <p className="text-xs md:text-sm text-white/80">{l}</p>
        </div>
      ))}
    </div>

    <H2>About Me</H2>
    <img
      src={swapnil}
      alt="Swapnil Gautam"
      className="w-40 h-40 md:w-52 md:h-52 object-cover rounded-3xl shadow-lg border-4 border-yellow-300 mx-auto md:float-right md:ml-6 md:mb-2"
    />
    <p>Hi, I’m Swapnil Gautam. Founder, Revibe Health and Happiness.</p>
    <p>
      I know what it feels like to struggle with weight. I was overweight for
      most of my life, tried different approaches, and eventually decided to
      transform myself. At 39, I lost 26 kg in 5 months—without crash diets or
      extreme workouts.
    </p>
    <p>
      That transformation gave me a bigger purpose: to make sustainable weight
      loss simple, practical and accessible for everyone.
    </p>
    <p>
      That’s why I built Revibe Health and Happiness. Today, Revibe brings
      together Clinical Dietitians, Fitness Trainers, Physiotherapists and
      Client Success Experts to provide complete, personalised support—from
      nutrition and home workouts to mindset, accountability and daily
      guidance.
    </p>
    <p>
      With 7000+ clients, we’re helping people across India and around the
      world become healthier, fitter and more confident—without depending on a
      gym or following unsustainable shortcuts.
    </p>
    <p>
      My journey started with transforming myself. Today, my mission is to help
      transform thousands of lives.
    </p>
    <p className="clear-both font-bold text-green-900 bg-yellow-100 rounded-2xl p-4 text-center text-lg">Your healthier, fitter life can start today.</p>

    <H2>About Revibe Health and Happiness</H2>
    <p>
      REVIBE HEALTH AND HAPPINESS is a registered Partnership Firm founded by
      Swapnil Gautam, Nirmal Zinabhai Patel, and Akash Ravishankar Shukla.
    </p>
    <p>
      All programs on this website are conducted by Swapnil Gautam, Partner at
      Revibe, who leads our mission to help Indians achieve Sustainable Weight
      Loss through Ayurveda and Neuroscience. As the face of Revibe’s coaching
      programs, Swapnil brings 10+ years of expertise in mindset transformation
      and holistic health.
    </p>
    <p>
      Revibe is the legal entity sponsoring and operating all webinars, diet
      programs, and health products promoted here. When you register, you are
      engaging directly with Revibe Health and Happiness.
    </p>
  </PolicyLayout>
);

export default AboutPage;
